// ** I18n Imports
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationAE from "../../assets/translation/locales/ae.json";
import translationCN from "../../assets/translation/locales/cn.json";
import translationDE  from "../../assets/translation/locales/de.json";
import translationEN from "../../assets/translation/locales/en.json";
import translationES from "../../assets/translation/locales/es.json";
import translationFR from "../../assets/translation/locales/fr.json";
import translationIT from "../../assets/translation/locales/it.json";
import translationPT from "../../assets/translation/locales/pt.json";
import translationRU from "../../assets/translation/locales/ru.json";
import translationVN from "../../assets/translation/locales/vn.json";

const resources = {
    de: {
        translation: translationDE
    },
    en: {
        translation: translationEN
    },
    es: {
        translation: translationES
    },
    fr: {
        translation: translationFR
    },
    it: {
        translation: translationIT
    },
    pt: {
        translation: translationPT
    },
    ru: {
        translation: translationRU
    },
    vn: {
        translation: translationVN
    },
    cn: {
        translation: translationCN
    },
    ae: {
        translation: translationAE
    }
};

i18n
// Enables the hook initialization module
    .use(initReactI18next)
    .init({
        resources,
        lng         : "en",
        fallbackLng : "en",
        debug       : false,
        keySeparator: false,
        react       : {
            useSuspense: true
        },
        interpolation: {
            escapeValue: false // Escaping is not needed for React
        }
    });

export default i18n;